import { createFileRoute } from "@tanstack/react-router";

import { StaffMemberPage } from "@/features/accounts/pages";

export const Route = createFileRoute("/_app/settings/staff/$userId")({
  component: StaffMember,
});

function StaffMember() {
  const { userId } = Route.useParams();
  return <StaffMemberPage key={userId} userId={userId} />;
}
